import React from 'react'
import '../../css/layout/Footer.scss'
import moment from 'moment'

const Footer = () => {
  return (
    <footer className="footer">
      <div>
        This page &copy;&nbsp;
        <a href="mailto:jsalonen@iki.fi">Jyrki Salonen</a>{' '}
        {moment().format('YYYY')}
      </div>
      <div>
        Data source and &copy;&nbsp;
        <a
          href="http://www.swpc.noaa.gov/"
          target="_blank"
          rel="noopener noreferrer"
        >
          NOAA
        </a>
      </div>
    </footer>
  )
}

export default Footer
